import { render, staticRenderFns } from "./vipOverview.vue?vue&type=template&id=6f4c393e&scoped=true"
import script from "./vipOverview.vue?vue&type=script&lang=js"
export * from "./vipOverview.vue?vue&type=script&lang=js"
import style0 from "./vipOverview.vue?vue&type=style&index=0&id=6f4c393e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4c393e",
  null
  
)

export default component.exports